import { PageHeader } from "@/components/PageHeader";
import { ButtonLink } from "@/components/ui";

export default function NotFound() {
  return (
    <div className="container container--narrow">
      <PageHeader
        eyebrow="404"
        title="Page not found"
        description="That URL doesn't match anything on this site."
      />
      <ButtonLink to="/" variant="primary">
        Back home
      </ButtonLink>
    </div>
  );
}
